var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { File } from "./File";
import { SubmissionProof } from "./SubmissionProof";
export class SubmissionPeriodFiles {
  constructor(_data) {
    /**
     */
    __publicField(this, "InvalidVatNumbersReportFiles");
    /**
     */
    __publicField(this, "NotToBeSubmittedProof");
    /**
     */
    __publicField(this, "ReturnFiles");
    /**
     */
    __publicField(this, "SubmissionProofs");
    /**
     */
    __publicField(this, "TransactionFiles");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SubmissionPeriodFiles
     */
    __publicField(this, "$type", "V1.Submission.SubmissionPeriodFiles");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["InvalidVatNumbersReportFiles"] && _data["InvalidVatNumbersReportFiles"].constructor === Array) {
        this.InvalidVatNumbersReportFiles = [];
        for (let item of _data["InvalidVatNumbersReportFiles"]) {
          const invalidVatNumbersReportFiles_ = new File();
          this.InvalidVatNumbersReportFiles.push(invalidVatNumbersReportFiles_.init(item));
        }
      }
      if (_data["NotToBeSubmittedProof"]) {
        const notToBeSubmittedProof_ = new File();
        this.NotToBeSubmittedProof = notToBeSubmittedProof_.init(_data["NotToBeSubmittedProof"]);
      }
      if (_data["ReturnFiles"] && _data["ReturnFiles"].constructor === Array) {
        this.ReturnFiles = [];
        for (let item of _data["ReturnFiles"]) {
          const returnFiles_ = new File();
          this.ReturnFiles.push(returnFiles_.init(item));
        }
      }
      if (_data["SubmissionProofs"] && _data["SubmissionProofs"].constructor === Array) {
        this.SubmissionProofs = [];
        for (let item of _data["SubmissionProofs"]) {
          const submissionProofs_ = new SubmissionProof();
          this.SubmissionProofs.push(submissionProofs_.init(item));
        }
      }
      if (_data["TransactionFiles"] && _data["TransactionFiles"].constructor === Array) {
        this.TransactionFiles = [];
        for (let item of _data["TransactionFiles"]) {
          const transactionFiles_ = new File();
          this.TransactionFiles.push(transactionFiles_.init(item));
        }
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.InvalidVatNumbersReportFiles && this.InvalidVatNumbersReportFiles.constructor === Array) {
      _data["InvalidVatNumbersReportFiles"] = [];
      for (let item of this.InvalidVatNumbersReportFiles) {
        _data["InvalidVatNumbersReportFiles"].push(item.toJSON());
      }
    }
    _data["NotToBeSubmittedProof"] = this.NotToBeSubmittedProof ? this.NotToBeSubmittedProof.toJSON() : void 0;
    if (this.ReturnFiles && this.ReturnFiles.constructor === Array) {
      _data["ReturnFiles"] = [];
      for (let item of this.ReturnFiles) {
        _data["ReturnFiles"].push(item.toJSON());
      }
    }
    if (this.SubmissionProofs && this.SubmissionProofs.constructor === Array) {
      _data["SubmissionProofs"] = [];
      for (let item of this.SubmissionProofs) {
        _data["SubmissionProofs"].push(item.toJSON());
      }
    }
    if (this.TransactionFiles && this.TransactionFiles.constructor === Array) {
      _data["TransactionFiles"] = [];
      for (let item of this.TransactionFiles) {
        _data["TransactionFiles"].push(item.toJSON());
      }
    }
    return _data;
  }
}
